(() => {
  const popup = document.querySelector("[data-free-shipping-popup]");
  if (!popup || typeof popup.showModal !== "function") return;

  const storageKey = "jazzis-free-shipping-popup-seen-this-session";
  const previewThemeId = new URLSearchParams(window.location.search).get("preview_theme_id");
  const inShopifyPreview = Boolean(
    (window.Shopify && window.Shopify.designMode) || previewThemeId
  );

  const wasSeen = (key) => {
    try {
      return !inShopifyPreview && window.sessionStorage.getItem(key) === "1";
    } catch {
      return false;
    }
  };
  const markSeen = (key) => {
    if (inShopifyPreview) return;
    try {
      window.sessionStorage.setItem(key, "1");
    } catch {}
  };
  const showShipping = () => {
    if (inShopifyPreview) return;
    if (wasSeen(storageKey) || popup.open) return;
    popup.show();
    markSeen(storageKey);
  };

  const closePopup = () => {
    if (popup.open) popup.close();
  };

  popup.querySelectorAll("[data-shipping-offer-close]").forEach((button) => {
    button.addEventListener("click", closePopup);
  });

  popup.addEventListener("click", (event) => {
    if (event.target === popup) closePopup();
  });

  window.setTimeout(showShipping, 700);
})();
